@if (loading()) {
  <lyceo-skeleton-text data-test="data-list-value-skeleton" />
} @else {
  <ng-content />
}
